// src/components/LoginWidget.jsx
import React from "react";

export default function LoginWidget({ loginData, setLoginData, handleLogin, setShowLogin, message }) {
  return (
    <div className="overlay-widget">
      <h2>Login</h2>
      <input
        type="text"
        placeholder="Username"
        maxLength={64}
        autoComplete="username"
        autoCapitalize="none"
        spellCheck={false}
        value={loginData.username}
        onChange={(e) =>
          setLoginData({ ...loginData, username: e.target.value })
        }
      />
      <input
        type="password"
        placeholder="Password"
        maxLength={1024}
        autoComplete="current-password"
        onKeyDown={(e) => { if (e.key === "Enter") handleLogin(); }}
        value={loginData.password}
        onChange={(e) =>
          setLoginData({ ...loginData, password: e.target.value })
        }
      />
      <button onClick={handleLogin}>Submit</button>
      <button onClick={() => setShowLogin(false)}>Close</button>
      {message && <p>{message}</p>}
    </div>
  );
}
